export function scrollToRealEstatesContent(behavior = 'smooth') {
  const contentSection = document.getElementById(
    'real-estates-content-section'
  );
  if (!contentSection) {
    return;
  }

  const marginTop = parseFloat(getComputedStyle(contentSection).marginTop) || 0;
  const targetY =
    contentSection.getBoundingClientRect().top + window.scrollY - marginTop;

  window.scrollTo({ top: targetY, behavior });
}
